import { supabase } from "@/integrations/supabase/client";

export interface MediaDraft {
  id: string;
  world_id: string;
  entity_id: string | null;
  created_by: string;
  image_type: string;
  entity_name: string;
  web_search_keywords: string;
  codex_search_keywords: string;
  codex_prompt: string;
  brief_text: string;
  generation_prompt: string;
  web_reference_images: string[];
  web_reference_thumbnails: string[];
  codex_snippets: string[];
  codex_entity_images: string[];
  selected_ref_images: string[];
  search_queries_used: string[];
  seed_image_url: string | null;
  drawing_data_url: string | null;
  creativity_level: number;
  selected_model: string;
  generated_image_url: string | null;
  accepted_image_url: string | null;
  debug_data: any;
  status: string;
  created_at: string;
  updated_at: string;
}

export async function loadDraftsForEntity(worldId: string, entityId: string): Promise<MediaDraft[]> {
  const { data } = await supabase
    .from("media_drafts" as any)
    .select("*")
    .eq("world_id", worldId)
    .eq("entity_id", entityId)
    .order("updated_at", { ascending: false })
    .limit(20);
  return (data as any[]) || [];
}

export async function loadDraftsForWorld(worldId: string): Promise<MediaDraft[]> {
  const { data } = await supabase
    .from("media_drafts" as any)
    .select("*")
    .eq("world_id", worldId)
    .order("updated_at", { ascending: false })
    .limit(50);
  return (data as any[]) || [];
}

export async function saveDraft(draft: Partial<MediaDraft> & { world_id: string; created_by: string }): Promise<MediaDraft | null> {
  const now = new Date().toISOString();
  const payload = { ...draft, updated_at: now };

  if (draft.id) {
    const { data, error } = await supabase
      .from("media_drafts" as any)
      .update(payload as any)
      .eq("id", draft.id)
      .select()
      .single();
    if (error) { console.error("Save draft error:", error); return null; }
    return data as any;
  } else {
    const { data, error } = await supabase
      .from("media_drafts" as any)
      .insert(payload as any)
      .select()
      .single();
    if (error) { console.error("Save draft error:", error); return null; }
    return data as any;
  }
}

export async function deleteDraft(draftId: string): Promise<boolean> {
  const { error } = await supabase
    .from("media_drafts" as any)
    .delete()
    .eq("id", draftId);
  return !error;
}
